import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=4210b05c&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=ts&"
export * from "./Stock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210b05c",
  null
  
)

export default component.exports